var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footer d-none d-md-flex",attrs:{"color":"blue darken-4","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("TESDA XI RTC-KorPhil Davao © 2020. All Rights Reserved.")])])}
var staticRenderFns = []

export { render, staticRenderFns }